import { Grid } from '@mui/material';
import DateRangeFilter from './DateRangeFilter';
import SelectFilter from './SelectFilter';
import SensorSelect from './SensorSelect';
import LoadingSearchButton from './LoadingSearchButton';

export default function TableFilters({
  startDate,
  endDate,
  handleStartDateChange,
  handleEndDateChange,
  dataType,
  handleDataTypeChange,
  prefix,
  handlePrefixChange,
  deviceOptions,
  smoothingType,
  setSmoothingType,
  handleSearch,
  loading,
  csvButton,
  selectedSensor,
  handleSensorChange,
}) {
  return (
    <>
      <Grid
        container
        spacing={2}
        mb={2}
        alignItems="center"
        justifyContent="center"
      >
        <DateRangeFilter
          startDate={startDate}
          endDate={endDate}
          handleStartDateChange={handleStartDateChange}
          handleEndDateChange={handleEndDateChange}
        />

        {dataType && handleDataTypeChange && (
          <SelectFilter
            label="Tipo de Datos"
            value={dataType}
            onChange={handleDataTypeChange}
            options={['Temperaturas', 'Eventos', 'Registros']}
          />
        )}

        {/* Equipo + Sensor en la misma fila */}
        <Grid item xs={12} sm={6}>
          <SelectFilter
            label="Equipo"
            value={prefix}
            onChange={handlePrefixChange}
            options={['Todos', ...deviceOptions.map((d) => d.table)]}
            displayOption={(val) => {
              if (val === 'Todos') return 'Todos';
              return deviceOptions.find((d) => d.table === val)?.name || val;
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <SensorSelect
            deviceOptions={deviceOptions}
            selectedSensor={selectedSensor}
            handleSensorChange={handleSensorChange}
            disabled={dataType !== 'Temperaturas'}
          />
        </Grid>

        <SelectFilter
          label="Suavizado"
          value={smoothingType}
          onChange={(e) => setSmoothingType(e.target.value)}
          options={['Sin suavizar', 'Suavizado por día', 'Suavizado por hora']}
          disabled={dataType !== 'Temperaturas'}
        />

        {/* Botones en la misma fila */}
      </Grid>
      <Grid
        container
        spacing={2}
        mb={2}
        alignItems="center"
        justifyContent="center"
      >
        <Grid item xs={12} sm={6}>
          <LoadingSearchButton onClick={handleSearch} loading={loading} />
        </Grid>
        {csvButton && (
          <Grid item xs={12} sm={6}>
            {csvButton}
          </Grid>
        )}
      </Grid>
    </>
  );
}
